import store from '~/javascripts/store.js';
import { observer } from 'mobx-react';

const CampaignRedirectBanner = observer(() => (
  <div className='campaign-redirect-banner bg-cw-brand-yellow-300 -mx-3 mb-3 py-2'>
    <div className='flex flex-col items-center justify-center'>
      <div
        className='show-for-large-up'
        dangerouslySetInnerHTML={{
          __html: store.donateForm.profileOwnerImageTag,
        }}
      />
      <div className='flex flex-col items-center'>
        <div className='body-m py-2'>
          Here to support{' '}
          <a
            className='body-m underline'
            href={store.donateForm.mostRecentOpenCampaign.publicPath}
          >
            {store.donateForm.mostRecentOpenCampaign.name}
          </a>
          ?
        </div>
      </div>
      <a
        className='button button--cw-yellow text-cw-black body-xs px-3'
        href={store.donateForm.mostRecentOpenCampaign.publicPath}
      >
        Support The Fundraiser
      </a>
      <p className='italic pt-2'>
        {store.donateForm.mostRecentOpenCampaign.daysLeft} days left to donate
      </p>
    </div>
  </div>
));

export default CampaignRedirectBanner;
